import axios        from 'axios';
import authHeader   from 'services/auth-header';
import Cookies      from 'universal-cookie';

const API_URL = process.env.REACT_APP_API_ENDPOINT;

class AssistantService {
  login(email, password) {
    return axios
      .post(API_URL + 'assistants/login', {
        email,
        password
      })
      .then(response => {
        if (response.data.auth_token) {
          var userHash        = response.data;
          userHash.user_type  = 'assistant';
          localStorage.setItem('user', JSON.stringify(userHash));
          localStorage.setItem('assistant', JSON.stringify(userHash));

          // Setting cookie for Old Dr Portal.
          const cookies = new Cookies();
          cookies.set('AuthSession', { 'token': 'Bearer ' + userHash.auth_token, 'user': userHash }, { path: '/' });
        }

        return response.data;
      });
  }

  forgotPassword(parameters) {
    return axios
      .post(process.env.REACT_APP_API_ENDPOINT + 'assistants/password', parameters)
      .then(response => {
        return response.data;
      }
    );
  }

  profile(id) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'assistants/' + id + '/profile', { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  // profile(id) { This gives exactly the same data as the login response. Keep here incase of future updates.
  //   return axios
  //     .get(process.env.REACT_APP_API_ENDPOINT + 'assistants/' + id + '/profile', { headers: authHeader() })
  //     .then(response => {
  //       return response.data;
  //     }
  //   );
  // }

  list_doctors(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'assistants/doctors_list/?' + parameters, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  selectDoctor(id) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'doctors/' + id + '/profile', { headers: authHeader() })
      .then(response => {
        if (response.data) {
          var userHash = response.data;
          userHash.user_type = 'doctor';
          localStorage.setItem('user', JSON.stringify(userHash));
          localStorage.removeItem('practice_location');
        }

        return response.data;
      }
    );
  }
}

export default new AssistantService();